module.exports = __webpack_public_path__ + "img/img-01.3c46da04.png";